module.exports = __webpack_public_path__ + "img/logo.af2b6c58.png";